import {
  FacultyAwards,
  FacultyPeers,
  FacultyPublications,
} from "Explore/Pages/FacultyDetail/Components";
import { Tabs, theme } from "antd";
import StickyBox from "react-sticky-box";
import styles from "./AcademicWorks.module.scss";
const AcademicWorks = ({
  tab,
  setTab,
  selectedKeywords,
  setSelectedKeywords,
  sliderValue,
  institutionId,
  publicationVerify,
  setPublicationVerify,
  tabDisableInformation,
}) => {
  const tabs = [
    {
      label: "Notable Scholarly Works",
      key: "publications",
      children: FacultyPublications,
      disabled: !tabDisableInformation.has_publications,
    },
    {
      label: "Notable Federal Grants",
      key: "grants",
      children: FacultyAwards,
      disabled: !tabDisableInformation.has_grants,
    },
    {
      label: "Collaborators",
      key: "collaborators",
      children: FacultyPeers,
      disabled: !tabDisableInformation.has_collaborators,
    },
  ];
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const renderTabBar = (props, DefaultTabBar) => (
    <StickyBox
      offsetTop={0}
      offsetBottom={20}
      style={{
        zIndex: 1,
      }}
    >
      <DefaultTabBar
        {...props}
        style={{
          background: colorBgContainer,
        }}
      />
    </StickyBox>
  );
  const onChange = (key) => {
    setTab(key);
    setSelectedKeywords([]);
  };
  return (
    <div className={styles["academic-work"]}>
      {window.screen.width > 900 ? (
        <div className={styles["tabs-landscape"]}>
          <Tabs
            onChange={onChange}
            type="card"
            items={tabs.map((item) => {
              return {
                label: item.label,
                key: item.key,
                children: (
                  <item.children
                    tab={tab}
                    verified={publicationVerify}
                    setVerified={setPublicationVerify}
                    selectedKeywords={selectedKeywords}
                    sliderValue={sliderValue}
                    institutionId={institutionId}
                  />
                ),
                disabled: item.disabled,
              };
            })}
          />
        </div>
      ) : (
        <div className={styles["tabs-mobile"]}>
          <Tabs
            onChange={onChange}
            className={styles["tabs-mobile__wrapper"]}
            defaultActiveKey="1"
            renderTabBar={renderTabBar}
            items={tabs.map((item) => {
              return {
                label: item.label,
                key: item.key,
                children: (
                  <item.children
                    tab={tab}
                    verified={publicationVerify}
                    setVerified={setPublicationVerify}
                    selectedKeywords={selectedKeywords}
                    sliderValue={sliderValue}
                    institutionId={institutionId}
                  />
                ),
                disabled: item.disabled,
              };
            })}
          />
        </div>
      )}
    </div>
  );
};

export default AcademicWorks;
